var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { greys } from "@irati/ui/src/global/colors";
import shareImg from "../images/share.svg";
var FlexRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n"], ["\n  align-items: center;\n  display: flex;\n"])));
var StyledImg = styled("img")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  background-color: ", ";\n  margin-right: 10px;\n"], ["\n  ",
    "\n  background-color: ", ";\n  margin-right: 10px;\n"])), function (_a) {
    var size = _a.size;
    return "\n    height: " + size + "px;\n    width: " + size + "px;\n  ";
}, greys.white);
var ShareRow = function (share) {
    return (React.createElement(FlexRow, null,
        React.createElement(StyledImg, { size: 15, src: shareImg }),
        React.createElement("div", null, share.label)));
};
export default ShareRow;
var templateObject_1, templateObject_2;
